import { Component, ElementRef, HostListener, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent, IonSelect, LoadingController } from '@ionic/angular';
import { Navigator } from 'src/app/components/menu/navigator';
import { DepositMainLabels } from 'src/app/interfaces/deposit-main-labels';
import { DepositMainModel } from 'src/app/models/deposit-models';
import { AddressService } from 'src/app/services/address/address.service';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { isUndefined } from 'src/app/services/codeUtils';
import { ConfigService } from 'src/app/services/config/config.service';
import { coutryPostalMatchValidator, creditCardExpiryValidator, DEPOSIT_PATTERN, NAME_PATTERNV2, POboxValidator, POboxValidatorGroup } from 'src/app/services/customFormValidators';
import { EventsService } from 'src/app/services/event/event.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { GlobalErrorHandlerService } from "src/app/services/global-errors/global-error-handler.service";
import { PurchaseService } from 'src/app/services/purchase/purchase.service';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import * as creditCardType from "credit-card-type";
import { ProgressingService } from 'src/app/services/progressing/progressing.service';
import { TaxInfo } from '../../payment-summary/payment-summary.component';

@Component({
  selector: "app-credit-card",
  templateUrl: "./credit-card.component.html",
  styleUrls: ["./credit-card.component.scss"],
})
export class CreditCardComponent implements OnInit {

  @ViewChild('content', { static: false }) content: IonContent;


  @ViewChild("widgetsContent",{read:ElementRef})
  public widgetsContent:ElementRef<any>;

  @Input() public bonusOffer: any;
  @Input() public navigateBackPage: any;
  @Input() price;
  @Input() priceCode;
  @Input() chips;
  @Input() credits;
  @Input() points;
  @Input() isAuthenticated;
  @Input() isSpecialOffer = false
  @Input() is_premium: boolean = false;
  @Input() is_Piggy_Bank = false;
  @Input() totalDays
  @Input() bonusCode;

  public error = null;

  public customer: any;
  public defaultAmounts: any = [];
  public labels: DepositMainLabels;
  public paymentType: any = [];
  public minAmount: any;
  public countries = [];
  public provinces;
  public cards: any = [];
  public selectedCard: string;
  public cardExpMonths: any = [];
  public cardExpYears: any = [];
  public selectedCountry: string = "";
  public selectedProvince: string = "";
  public selectedCountryCode: string = "";
  public stateProvinceLabel: string = "";
  public zipPostalCodeLabel: string = "";

  public selectedMonth: string;
  public selectedYear: string;
  public buttonDisabled: boolean = false;

  public isExistingCard: boolean;
  public isExistingCardList: boolean;
  public showCVV: boolean = false;

  public purchaseForm: FormGroup;
  public amount: AbstractControl;
  public paymentTypeCode: AbstractControl;
  public country: AbstractControl;
  public province: AbstractControl;
  public cardList: AbstractControl;
  public cardNumber: AbstractControl;
  public cardCvc: AbstractControl;
  public cardExpiryGroup: AbstractControl;
  public cardExpMonth: AbstractControl;
  public cardExpYear: AbstractControl;
  public streetGroup: AbstractControl;
  public street: AbstractControl;
  public street2: AbstractControl;
  public city: AbstractControl;
  public countryInfoGroup: AbstractControl;
  public postalCode: AbstractControl;
  public name: AbstractControl;
  public firstName: AbstractControl;
  public lastName: AbstractControl;
  private customerAccountId;
  public taxInfo:TaxInfo = {};
  public payment_type_code;
  private accountInfo;

  creditCardPaymentStatus = {
    ADDCARD: 'ADDCARD',
    SUMMARY: 'SUMMARY'
  };

  // views: ADDCARD, SUMMARY
  protected screenName: string = this.creditCardPaymentStatus.ADDCARD;

  public isAVS: boolean = this.configService.getConfig().FEATURE_CREDITCARD_AVS == "1";
  public loading: any;
  maxCCYears: number;
  refreshed: boolean = false;
  private itemInfo
  private countryList =  this.configService.getConfig().FEATURE_COUNTRY_LIST || [];
  @ViewChildren(IonSelect) ionSelect: QueryList<IonSelect>;

  constructor(
    public addressService: AddressService,
    public cashierService: CashierService,
    public cashierContentService: CashierContentService,
    public configService: ConfigService,
    public events: EventsService,
    public navigator: Navigator,
    public UserSessionService: UserSessionService,
    public utils: UtilsService,
    public successMessageService: SuccessMessageService,
    public loadingController: LoadingController,
    private purchase:PurchaseService,
    private balanceService:AccountBalanceService,
    private progressSerice: ProgressingService
  ) {
    // super();
    this.screenName = this.creditCardPaymentStatus.ADDCARD;
    this.getCustomer();
    this.successMessageService.clearMessage();
    this.labels = new DepositMainModel();
  }

  async showLoading() {
    this.loading = await this.loadingController.create({
      message: 'Loading...',
      duration: 3000
    });

    this.loading.present();
  }

  ngOnInit() {
    this.maxCCYears = Number(this.configService.getConfig().FEATURE_CREDIT_CARD_EXPIRY_MAX_YEARS) || 15;

    this.selectedCountry = this.configService.getConfig().FEATURE_SITE_COUNTRY_REGION ? this.configService.getConfig().FEATURE_SITE_COUNTRY_REGION : 'USA';
    // if (this.selectedCountry === 'CANADA') {
    //   this.selectedCountryCode = 'CAN';
    //   this.stateProvinceLabel = 'Province';
    //   this.zipPostalCodeLabel = 'Postal Code';
    // } else {
      this.selectedCountryCode = 'USA';
      this.stateProvinceLabel = 'State';
      this.zipPostalCodeLabel = 'Zip Code';
    // }

    this.purchaseForm = new FormGroup({
     // amount: new FormControl({ value: '', disabled: false }, { validators: [Validators.pattern(DEPOSIT_PATTERN), Validators.required], updateOn: 'change' }),
      cardList: new FormControl({ value: '', disabled: false }),
      paymentTypeCode: new FormControl({ value: '', disabled: false }, []),
      countryInfoGroup: new FormGroup({
        country: new FormControl({ value: '', disabled: this.isNotEditable() }, [Validators.required]),
        postalCode: new FormControl({ value: '', disabled: this.isNotEditable() }, [Validators.required])
      }, coutryPostalMatchValidator),
      cardNumber: new FormControl({ value: '', disabled: false }, [Validators.required, this.creditCardValidator]),
      cardExpiryGroup: new FormGroup({
        cardExpMonth: new FormControl({ value: '', disabled: false }, [Validators.required]),
        cardExpYear: new FormControl({ value: '', disabled: false }, [Validators.required]),
      }, creditCardExpiryValidator),
      name: new FormControl({ value: '', disabled: this.isNotEditable() }, [Validators.required, Validators.pattern(NAME_PATTERNV2)]),
      cardCvc: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.minLength(3), Validators.pattern('^[0-9]*')]),
      streetGroup: new FormGroup({
        street: new FormControl({ value: '', disabled: this.isNotEditable() }, [Validators.required, POboxValidator]),
        street2: new FormControl({ value: '', disabled: this.isNotEditable() }, [POboxValidator]),
      }, POboxValidatorGroup),
      city: new FormControl({ value: '', disabled: this.isNotEditable() }, [Validators.required]),
      province: new FormControl({ value: '', disabled: this.isNotEditable() }, [Validators.required]),
    });


    // Getting Form Data
    // this.amount = this.purchaseForm.get('amount');
    this.cardNumber = this.purchaseForm.get('cardNumber');
    this.cardList = this.purchaseForm.get('cardList');
    this.paymentTypeCode = this.purchaseForm.get('paymentTypeCode');

    this.cardExpiryGroup = this.purchaseForm.get('cardExpiryGroup');
    this.cardExpMonth = this.cardExpiryGroup.get('cardExpMonth');
    this.cardExpYear = this.cardExpiryGroup.get('cardExpYear');

    this.name = this.purchaseForm.get('name');
    this.cardCvc = this.purchaseForm.get('cardCvc');

    this.streetGroup = this.purchaseForm.get('streetGroup');
    this.street = this.streetGroup.get('street');
    this.street2 = this.streetGroup.get('street2');
    this.countryInfoGroup = this.purchaseForm.get('countryInfoGroup');
    this.country = this.countryInfoGroup.get('country');
    this.postalCode = this.countryInfoGroup.get('postalCode');
    this.province = this.purchaseForm.get('province');
    this.city = this.purchaseForm.get('city');

    this.onGetAccounts(false);
    this.generateExpiryMonths();

    this.itemInfo = {
      price: this.price,
      chips: this.chips,
      credits: this.credits,
      points: this.points,
      isAuthenticated: this.isAuthenticated,
      is_premium:this.is_premium,
      totalDays:this.totalDays
    };
    this.changeSelectInterface();
    if(!this.price) {
      this.loadExternalOffers();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event:Event) {
    this.changeSelectInterface();
  }

  changeSelectInterface() {
    setTimeout(() => {
      this.ionSelect.forEach((ionSelect: IonSelect) => {
        if(ionSelect){
          ionSelect.interface = this.isMobile() ?  "alert" : "popover";
        }
      });
    }, 1000);
  }

 isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  creditCardValidator(control) {
    const value = control.value.replace(/\s/g, ''); // Remove spaces
    const cardTypes = {
      visa: { regex: /^4\d{15}$/, isValid: (value) => value.length === 15 || value.length === 16 },
      mastercard: { regex: /^(?:[25][1-5][0-9]{14})$/, isValid: (value) => value.length === 16 },
      amex: { regex: /^3[47]\d{13}$/, isValid: (value) => value.length === 15 },
      discover: { regex: /^6(?:011|5\d{2})\d{12}$/, isValid: (value) => value.length === 16 }
    };
    for (const cardType in cardTypes) {
      if (cardTypes.hasOwnProperty(cardType)) {
        const cardTypeObj = cardTypes[cardType];
        if (cardTypeObj.regex.test(value) && cardTypeObj.isValid(value)) {
          return null; // Card type is valid
        }
      }
    }
    return { 'invalidCreditCard': true };
  }

  onBlur(paymentType?) {
    const cardNumber: any = !paymentType ? this.purchaseForm.controls['cardNumber'] ? this.purchaseForm.controls['cardNumber'].value : "" : "";
    const amexRegex = /^3[47]\d{13}$/;
    const validatorsList = (amexRegex.test(cardNumber) || (paymentType && paymentType == "AM")) ? [Validators.required, Validators.minLength(4), Validators.pattern('^[0-9]*')] :
    [Validators.required, Validators.minLength(3), Validators.maxLength(3), Validators.pattern('^[0-9]*')];
    // this.purchaseForm.get("cardCvc").setValidators(validatorsList);
    // this.purchaseForm.get("cardCvc").updateValueAndValidity();
  }

  ionViewDidEnter() {
    this.successMessageService.clearMessage();
    this.cashierService.getActivePaymentTypes('CREDIT').subscribe((response: any) => {
      if (response.result) {
        this.paymentType = response.payload;
      }
    }, (error) => {
      console.error("Type category error", error);
    }
    );
    this.getAllCountries();
    this.scrollToTop();
  }

  ngAfterViewInit() {
    this.cashierContentService.getPageConfig('creditcard').then((response: DepositMainLabels) => {
      this.labels = response;
    });
    this.getAllCountries();
  }

  public onSubmit() {
    if (this.isExistingCard == true) return this.clickContinue();
    return this.onAddCard();
  }
  getFormValuesWithoutcvs() {
    const formValues = this.purchaseForm.value;
    delete formValues.streetGroup.cardCvc;
    return formValues;
  }

 private loadExternalOffers(){
    const external = 'web';
    this.purchase.getAllPurchases(external).subscribe((resp) => {
      if (resp.result && resp.payload) {
        let externalOffer = resp.payload.filter((item) => item.priceCode == this.priceCode)
        if(externalOffer[0])
          this.price  = externalOffer[0].priceAmount;
      }
    })
  }

  private async clickContinue() {
    try {
      this.progressSerice.show();
      await this.updateAccount();
      const customerAccountId = this.getCustomerAccountIdID();
      const purchase = this.getPurchaseType();
      this.taxInfo = {
        purchase: purchase,
        coins: this.chips,
        paymentType: 'Credit Card (' + (this.accountInfo ? this.accountInfo : '') +')',
      };

      this.purchase.getTaxInfo(this.price, customerAccountId).subscribe(
        (res) => {
          this.progressSerice.hide();
          this.screenName = this.creditCardPaymentStatus.SUMMARY;
          if (res && res.payload) {
            const payload = res.payload;
            if (payload === null || Object.keys(payload).length === 0) {
              this.taxInfo.total = +this.price;
            } else {
              this.taxInfo.taxPercent =  ("taxPercent" in payload)  ?  this.removeTrailingZero(payload.taxPercent) :0;
              this.taxInfo.provTax =     ("taxAmount" in payload)  ? payload.taxAmount.toFixed(2) : 0;
              this.taxInfo.beforeTax =   payload.amountBeforeTax || this.price;
              this.taxInfo.total =       payload.amountAfterTax || this.price;
            }
          } else {
            this.taxInfo.total = +this.price;
          }
        },
        (error) => {
          this.progressSerice.hide();
          this.handleTaxInfoError(error);
        }
      );
    } catch (error) {
      this.progressSerice.hide();
      this.handleUpdateAccountError(error);
    }
  }

  private removeTrailingZero(number) {
    let numberStr = number.toString();

    if (numberStr.includes('.') && numberStr.split('.')[1].length === 3) {
        // Remove the trailing zero if present (quebec 3 digits after the dot)
        if (numberStr.endsWith('0')) {
            numberStr = numberStr.slice(0, -1);
        }
    }

    return numberStr;
  }

  private roundUpToTwoDecimalPlaces(value: any): number | null {
    if (typeof value === 'number') {
      return Math.ceil(value * 100) / 100;
    }
     return null;
  }

  private handleTaxInfoError(error: any) {
    this.screenName = this.creditCardPaymentStatus.SUMMARY;
    this.taxInfo.total = +this.price;
    this.taxInfo.beforeTax = this.price;
  }

  private handleUpdateAccountError(error: any) {
    this.progressSerice.hide();
    this.onFailure('PurchaseSuccessFailureComponent',error);
    this.error = this.handleError(error);
    this.buttonDisabled = true;
    this.scrollToTop();
  }

  protected updateAccount() {
    return new Promise((resolve, reject) => {
      let purchaseFormObj: any = this.purchaseForm.value;
      const customerAccountId = this.getCustomerAccountIdID();
      try {
        purchaseFormObj = {
          ...purchaseFormObj,
          payment_type_code: this.payment_type_code,
          address1: this.purchaseForm.get('streetGroup.street').value,
          address2: this.purchaseForm.get('streetGroup.street2').value,
          country: this.purchaseForm.get('countryInfoGroup.country').value,
          postalCode: this.purchaseForm.get('countryInfoGroup.postalCode').value,
          state: this.purchaseForm.get('province').value,
          city: this.purchaseForm.get('city').value,
          cardExpMonth: this.purchaseForm.get('cardExpiryGroup.cardExpMonth').value,
          cardExpYear: this.purchaseForm.get('cardExpiryGroup.cardExpYear').value,
          cardCvd: this.purchaseForm.get('cardCvc').value,
          acctId: customerAccountId
        };
        const unwantedProps = ['cardExpiryGroup', 'streetGroup', 'countryInfoGroup', 'cardList', 'paymentTypeCode', 'cardCvc'];
        unwantedProps.forEach(prop => delete purchaseFormObj[prop]);
        this.purchase.updateAccount(purchaseFormObj).subscribe(
          (resp) => {
            resolve(true)
            setTimeout(() => {
              this.onGetAccounts(false, customerAccountId);
            }, 1000);
          },
          (error) => {
            reject(error);
          }
        );
      } catch (e) {
        resolve(false);
      }
    });
  }


  protected getPurchaseType() {
    if (this.isSpecialOffer) {
      return "Special Offer";
    }
    if (this.is_Piggy_Bank) {
      return "Piggy bank";
    }
    if (this.is_premium) {
      return "Premium Bonus";
    }
    return "Coins purchase";
  }

  protected getCustomerAccountIdID() {
    let customerAccountId;
    if (this.isExistingCard == true) {
      let cardList: AbstractControl = this.purchaseForm.get('cardList');
      let index: number = cardList.value;
      if (this.cards[index]) {
        customerAccountId = this.cards[index].customerAccountID;
        this.payment_type_code = this.cards[index].paymentTypeCode;
        this.accountInfo = this.cards[index].accountInfo;
      }
    } else {
      customerAccountId = this.customerAccountId;
    }
    return customerAccountId;
  }

  onClickPurchase() {
    const customerID = this.getCustomerAccountIdID();
    this.onPurchase(customerID);
  }

  onClickBack() {
    this.screenName = this.creditCardPaymentStatus.ADDCARD;
  }

  public getCustomer() {
    this.UserSessionService.getCustomerSubscription().then((customerSubscription) => {
      customerSubscription.subscribe((customer) => {
        this.customer = customer;
      });
    });
  }

  public onGetAccounts(justRefreshList: boolean, customerAccountId?) {
    this.cards = [];
    this.cashierService.callListAccounts().subscribe((response: any) => {
      if (response && !!response.result) {
        let tempCards: any = response.payload;
        let i = 0;

        for (let index in tempCards) {
          if (this.cardFilter(tempCards, index)) {
            tempCards[index].id = i;
            i++;
            this.cards.push(tempCards[index]);
          }
        }
        let index = 0;
        if(customerAccountId && this.cards.length){
         index = this.cards.findIndex(item => item.customerAccountID === customerAccountId);
        }

        if (!!this.cards[index]) {
          this.preFillInfo(index)
          this.onBlur(this.cards[0].payment_type_code)
          this.isExistingCardList = true;
        }

        if (justRefreshList == false) {
          this.onLoadElement();
        }
      }
    });
  }

  preFillInfo(index){
    this.selectedCard = this.cards[index].id.toString();
    this.selectedMonth = this.cards[index].expirationMonth.toString();
    this.selectedYear = this.cards[index].expirationYear.toString();

    this.streetGroup.get("street").setValue(this.cards[index].address1);
    if (!isUndefined(this.cards[index].address2) && !(/^\s+$/g.test(this.cards[index].address2))) {
      this.streetGroup.get("street2").setValue(this.cards[index].address2);
    } else {
      this.streetGroup.get("street2").setValue("");
    }

    if (!isUndefined(this.cards[index].postalCode)) {
      this.countryInfoGroup.get("postalCode").setValue(this.cards[index].postalCode);
    } else {
      this.countryInfoGroup.get("postalCode").setValue("");
    }

    setTimeout(() => {
      if (!isUndefined(this.cards[index].state)) {
        this.purchaseForm.get("province").setValue(this.cards[index].state);
      }
    }, 1000);


    if (this.countries.length > 0) {
      this.countryInfoGroup.get('country').setValue(this.cards[index].country);
    }

    if (this.name && this.cards[index].firstName) {
      if(this.cards[index].lastName){
        this.name.setValue(this.cards[index]?.firstName + ' ' + this.cards[index]?.lastName);
      } else {
        this.name.setValue(this.cards[index]?.firstName)
      }
    }

    this.purchaseForm.get('city').setValue(this.cards[index].city);
  }

  public cardFilter(cards, index) {
    if (cards[index].paymentTypeCode == "VI") return true;
    if (cards[index].paymentTypeCode == "MC") return true;
    if (cards[index].paymentTypeCode == "AM") return true;
    if (cards[index].paymentTypeCode == "DIS") return true;
    return false;
  };

  public onAddCard() {
    this.buttonDisabled = false;
    this.successMessageService.clearMessage();
    this.error = null;

    let addCardFormObj: any = this.purchaseForm.value;
    let payment_type_code: string = this.purchaseForm.controls['paymentTypeCode'].value;
    const cardTypeResults = this.purchaseForm.controls['cardNumber'].value ? this.getCardType(this.purchaseForm.controls['cardNumber'].value) : { result: false };
    if(cardTypeResults.result){
      addCardFormObj.payment_type_code = cardTypeResults.code
    }

    if(this.cashierService.customer.preferredCurrency?.currencyCode){
    addCardFormObj.currency_code = this.cashierService.customer.preferredCurrency.currencyCode;}
    else{
    addCardFormObj.currency_code ='PLAY'
    }
    addCardFormObj.cardExpMonth = this.cardExpiryGroup.get('cardExpMonth').value;
    addCardFormObj.cardExpYear = this.cardExpiryGroup.get('cardExpYear').value;
    this.progressSerice.show();

    this.cashierService.callAddAccount(addCardFormObj).subscribe((response: any) => {
      this.progressSerice.hide();
      if (response && !!response.result) {
        if (response.payload != null) {
          this.customerAccountId = response.payload.customerAccountID;
          this.payment_type_code = addCardFormObj.payment_type_code
          this.accountInfo = this.getLastDigits(addCardFormObj.cardNumber);
          return this.clickContinue();
        }
      }
      this.scrollToTop();
      this.buttonDisabled = true;
    }, (error) => {
      this.progressSerice.hide();
      this.onFailure('PurchaseSuccessFailureComponent',error);
      this.error = this.handleError(error);
      this.buttonDisabled = true;
      this.scrollToTop();
    });
  }

  getLastDigits(num) {
    const lastDigits = 4;
    const numStr = num.toString();
    return numStr.slice(-lastDigits);
  }

  onPurchase(customerAccountID?: string) {
    // this.content.scrollToTop(10);

    this.buttonDisabled = false;
    this.successMessageService.clearMessage();
    this.error = null;

    let purchaseFormObj: any = this.purchaseForm.value;
    try {
    purchaseFormObj.address1 = this.purchaseForm.get('streetGroup.street').value;
    purchaseFormObj.address2 = this.purchaseForm.get('streetGroup.street2').value;
    purchaseFormObj.country = this.purchaseForm.get('countryInfoGroup.country').value;
    purchaseFormObj.postalCode = this.purchaseForm.get('countryInfoGroup.postalCode').value;
    purchaseFormObj.state = this.purchaseForm.get('province').value;
    purchaseFormObj.city = this.purchaseForm.get('city').value;
    purchaseFormObj.cardCvd = this.purchaseForm.get('cardCvc').value;
    const cardExpiryGroup = this.purchaseForm.get('cardExpiryGroup');
    purchaseFormObj.cardExpMonth = cardExpiryGroup.get('cardExpMonth').value;
    purchaseFormObj.cardExpYear = cardExpiryGroup.get('cardExpYear').value;
    delete purchaseFormObj.cardExpiryGroup;
    delete purchaseFormObj.streetGroup;
    delete purchaseFormObj.countryInfoGroup;
    delete purchaseFormObj.cardList;
    delete purchaseFormObj.paymentTypeCode;
    delete purchaseFormObj.cardCvc;
    }catch(e){
      console.log("error",e)
    }

    if(this.cashierService.customer.preferredCurrency?.currencyCode){
      purchaseFormObj.currency_code = this.cashierService.customer.preferredCurrency.currencyCode;}
      else{
        purchaseFormObj.currency_code ='PLAY'
      }

    if (this.isExistingCard == true) {
      let cardList: AbstractControl = this.purchaseForm.get('cardList');
      let index: number = cardList.value;

     purchaseFormObj.payment_type_code = this.cards[index].paymentTypeCode;
      purchaseFormObj.customerAccountID = this.cards[index].customerAccountID;
    } else {
      purchaseFormObj.customerAccountID = customerAccountID;
    }

  purchaseFormObj.price_code = this.priceCode
  purchaseFormObj.is_premium = this.is_premium;
  purchaseFormObj.is_special_offer = this.isSpecialOffer;
  if (this.bonusCode&&this.isSpecialOffer){
    purchaseFormObj.price_code = this.bonusCode
  }
  purchaseFormObj = this.removeUndefined(purchaseFormObj);
  if(!this.is_Piggy_Bank){
       this.purchaseCoins(purchaseFormObj);}
   else{
       this.breakPiggyBank(purchaseFormObj)
     }

  }

  removeUndefined(obj) {
    for (const key in obj) {
      if (obj[key] === undefined) {
        delete obj[key];
      }
    }
    return obj;
  }

public purchaseCoins(purchaseFormObj){
  this.progressSerice.show();
  this.purchase.purchaseCoins(purchaseFormObj).subscribe((response: any) => {
    this.progressSerice.hide();
    if (response && !!response.result) {
      if (response.payload) {
        if (response.payload.boyd_points !== undefined) {
          this.itemInfo.points = response.payload.boyd_points;
        }
        if (response.payload.tier_credits !== undefined) {
          this.itemInfo.credits = response.payload.tier_credits;
        }
      }

       this.onSuccess('PurchaseSuccessFailureComponent');
    } else {
       this.onFailure('PurchaseSuccessFailureComponent',this.error);
     }
    this.buttonDisabled = true;

  }, (error) => {
    console.log("error ", error.getErrorCode().toUpperCase())
    this.onClickBack();
    this.buttonDisabled = true;
    this.error = this.handleError(error);
    console.log("error this ", this.error)
    setTimeout(() =>
    {
      this.progressSerice.hide();
      // this.navigator.navigateTo('PurchaseSuccessFailureComponent', { customModalClass: 'custom-shop-model-class-transparent', backdropDismiss: true }, { status: false, message: this.error.error_message})
    }, 1500)
    this.onFailure('',error);
  });

 }
  onSuccess(component?:string) {
  setTimeout(() => this.purchaseForm.reset(), 500);
  if(this.loading){
    this.loading.dismiss();
  }
  const displayMessage: string = "Purchase Sucess";
  this.balanceService.updateBalance();
  this.navigator.navigateTo(component, { customModalClass: 'custom-shop-model-class-transparent', backdropDismiss: true }, { status: true, message: displayMessage,...this.itemInfo  });
 }
 onFailure(component:string,error) {
  if(this.loading){
    this.loading.dismiss();
  }
  this.error = error;
  this.scrollToTop();


      //this.navigator.navigateTo(component, { customModalClass: 'custom-shop-model-class-transparent', backdropDismiss: true }, { status: false, message: 'Please Contact Support' });
 }

public breakPiggyBank(purchaseFormObj){
  this.progressSerice.show();
   this.purchase.breakPiggy(purchaseFormObj).subscribe((response: any) => {
    this.progressSerice.hide();
    if (response && !!response.result) {
      if (response.payload) {
        if (response.payload.boyd_points !== undefined) {
          this.itemInfo.points = response.payload.boyd_points;
        }
        if (response.payload.tier_credits !== undefined) {
          this.itemInfo.credits = response.payload.tier_credits;
        }
      }
      this.onSuccess('PurchaseSuccessFailureComponent');
    }
    else{
     this.onFailure('PurchaseSuccessFailureComponent',this.error);
    }
  },error => {
    this.onFailure('PurchaseSuccessFailureComponent',error)
  })
}


  public onChangeCountry(event) {
    this.getProvinces(event.target.value)
    this.settingLabels();
  }

  public onPaymentType(data) {

    let i: number = 0;

    this.defaultAmounts = [];

    while (i < 11) {
      if (typeof this.paymentType[data]['default_amt_' + (i + 1)] !== 'undefined') {
        this.defaultAmounts.push(this.paymentType[data]['default_amt_' + (i + 1)])
      } else {
        break;
      }
      i++;
    }
  }

  public onLoadElement() {
    if (this.cards.length > 0) {
      this.isExistingCard = true;
      this.buttonDisabled = false;
      this.purchaseForm.removeControl("cardNumber");
      this.purchaseForm.removeControl("paymentTypeCode");
      return this.getAllCountries();
    }

    this.isExistingCard = false;
    this.onUseDifferentCard()
    return this.getAllCountries();
  }

  public onUseDifferentCard() {
    this.isExistingCard = false;
    this.buttonDisabled = true;
    //this.purchaseForm.removeControl("cardList");
    this.purchaseForm.addControl("cardNumber", this.cardNumber);
    this.purchaseForm.addControl("paymentTypeCode", this.paymentTypeCode);
   // this.purchaseForm.get("cardNumber").setValidators([Validators.required, Validators.minLength(15), Validators.maxLength(16), Validators.pattern('^[0-9]*')]);
    this.purchaseForm.get("cardNumber").setValue("");
    this.purchaseForm.get("cardNumber").markAsPristine();
    this.purchaseForm.get("cardNumber").markAsUntouched();
    // this.purchaseForm.addControl("streetGroup", this.streetGroup);

    this.streetGroup.get("street").setValue("");
    if (!isUndefined(this.customer.address.street2) && !(/\s+/g.test(this.customer.address.street2))) {
      this.streetGroup.get("street2").setValue("");
    } else {
      this.streetGroup.get("street2").setValue("");
    }

    // this.purchaseForm.addControl("countryInfoGroup", this.countryInfoGroup);
    this.countryInfoGroup.get("postalCode").setValue("");
    // this.purchaseForm.addControl("province", this.province);
    this.purchaseForm.get("province").setValue("");
    // this.purchaseForm.addControl("city", this.city);
    this.purchaseForm.get("city").setValue("");
    this.purchaseForm.get("name").setValue("");

    this.onClearFields();
    this.isExistingCard = false;
    this.selectedMonth = "";
    this.selectedYear = "";
  }

  public onRadioChecked(index: number) {
    this.isExistingCard = true;
    this.buttonDisabled = true;
    if(this.cards[index]) this.onBlur(this.cards[index].paymentTypeCode);

    if(this.cards[index]){
      this.preFillInfo(index);
    }

    //this.onGetAccounts(false);
    this.purchaseForm.removeControl("cardNumber");
    this.onClearFields();
    this.buttonDisabled = false;
    this.settingLabels();
  }

  public onClearFields() {
    this.purchaseForm.get("cardCvc").setValue("");
    this.purchaseForm.get("cardCvc").markAsPristine();
    this.purchaseForm.get("cardCvc").markAsUntouched();
  }

  public getAllCountries() {
    if (this.countryList.length) {
      this.countries = [];
      this.setCountryList(JSON.parse(this.countryList));
    } else {
      this.addressService.callGetAllCountries().subscribe((response: any) => {
        if (response && !!response.result) {
          this.setCountryList(response.payload);
        }
      }, error => {
        this.error = this.handleError(error);
        this.scrollToTop();
      });
    }
  }

  private setCountryList(countryList){
    const countriesList: any = countryList;
    let cardSelected: any = this.cards.filter((card) => card.id == this.selectedCard);
    for (let c in countriesList) {
      this.countries.push(countriesList[c]);
    }

    this.selectedCountry = this.onSelectCountry(cardSelected, countriesList);
    if (this.selectedCountry === 'CANADA') {
      this.selectedCountry = "CAN"
      let indexOfCanada = countriesList.findIndex(({ name }) => name === 'CANADA');
      let canadaObject = countriesList[indexOfCanada]
      if (this.countries[0].code !== canadaObject.code && (indexOfCanada !== -1)) {
          this.countries.splice(indexOfCanada, 1);
          this.countries.unshift(canadaObject);
      }
      this.selectedCountryCode = 'CAN';
      this.stateProvinceLabel = 'Province';
      this.zipPostalCodeLabel = 'Postal Code';
    } else {
      this.selectedCountryCode = 'USA';
      this.stateProvinceLabel = 'State';
      this.zipPostalCodeLabel = 'Zip Code';
    }
    let formGroup = this.purchaseForm.get('countryInfoGroup');
    formGroup.get('country').patchValue(this.selectedCountryCode);
    this.updateCountryField();
    this.getProvinces();

  }

  settingLabels() {
    const selectedCountryCanada = (this.selectedCountry === 'CANADA' || this.selectedCountry === 'CAN');
    this.selectedCountryCode = selectedCountryCanada ? 'CAN' : 'USA';
    this.stateProvinceLabel = selectedCountryCanada ? 'Province' : 'State'; '';
    this.zipPostalCodeLabel = selectedCountryCanada ? 'Postal Code' : 'Zip Code'; '';
  }

  public onSelectCountry(cardSelected: any, countriesList: any): any {
    const country = this.configService.getConfig().FEATURE_SITE_COUNTRY_REGION ? this.configService.getConfig().FEATURE_SITE_COUNTRY_REGION : 'USA';
    if (!!cardSelected && cardSelected.length > 0) return (cardSelected[0].country ? (cardSelected[0].country == 'CAN' ? 'CANADA' : 'USA') : 'USA');
    if (this.countries.length >= 1) return country;
    return this.customer.address.country;
  }

  //Force ion-select interface to display the value in UI.
  public updateCountryField(){
    setTimeout(() => {
      this.refreshed = true;
    }, 500);
  }

  public getProvinces(country?: any) {

    let countryName = country ?? this.selectedCountry;

    return new Promise((resolve, reject) => {
      this.addressService.callGetStatesByCountry(countryName === "CANADA" ? "CAN" : countryName).subscribe((response: any) => {
        if (response && !!response.result) {

          const provs = response.payload;
          this.provinces = [];
          for (let p in provs) {
            this.provinces.push({ code: p, name: provs[p] })
          }

          let cardSelected = this.cards.filter((card) => {
            return card.id === this.selectedCard;
          });

          if (cardSelected.length > 0) {
            this.selectedProvince = cardSelected[0].state;
            return resolve(true);
          }

          if (this.customer.address.state)
            this.selectedProvince = this.customer.address.state;
          return resolve(true);
        }
      }, (error) => {
        this.error = this.handleError(error);
        this.scrollToTop();
        reject();
      });
    })
  }

  public isNotEditable() {
    if (this.isAVS) return true;
    return false;
  }

  public radioChangedCard(e) {
    if (e.target.value == 'diff') return this.onUseDifferentCard();
    return this.onRadioChecked(e.target.value);
  }

  // public onAmountSelected(data) {
  //   return this.purchaseForm.get('amount').setValue(data);
  // }

  public generateExpiryMonths() {
    this.cardExpMonths = [
      { key: '1', value: 'Jan (1)' },
      { key: '2', value: 'Feb (2)' },
      { key: '3', value: 'Mar (3)' },
      { key: '4', value: 'Apr (4)' },
      { key: '5', value: 'May (5)' },
      { key: '6', value: 'Jun (6)' },
      { key: '7', value: 'Jul (7)' },
      { key: '8', value: 'Aug (8)' },
      { key: '9', value: 'Sep (9)' },
      { key: '10', value: 'Oct (10)' },
      { key: '11', value: 'Nov (11)' },
      { key: '12', value: 'Dec (12)' },
    ];

    let d = new Date();
    let y = d.getFullYear();
    let i;

    for (i = 0; i <= this.maxCCYears; i++) {
      this.cardExpYears.push(y + i);
    }
    return;
  }
  setSightlineErrorMessage(error, message) {
    // @todo impoort Siteline error service
    // let sightlineErrors = new SightLineErrors(message);
    //let setErrorMessage = sightlineErrors.getError();
    //error.setErrorMessage(setErrorMessage);
}
  handleError(error: GlobalErrorHandlerService) {
    let customerCareGP = 'For further assistance please contact Global Payments Gaming Services customer support at 1-800-500-1973, with reference code';

    switch (error.getErrorCode().toUpperCase()) {
        // Global Pay errors
        case '02':
            error.setErrorMessage(`We’re sorry, but we are unable to proceed with your transaction. This decision was based in whole or in part on information obtained from the consumer-reporting agency <a href="https://www.vippreferred.com/fcra-decline-notice">https://www.vippreferred.com/fcra-decline-notice</a>`);
            break;
        case '10':
            error.setErrorMessage(`Unexpected Application Error. ${customerCareGP} E10`);
            break;
        case '11':
            error.setErrorMessage(`The dollar amount of this check transaction has exceeded the available limit`);
            break;
        case '12':
            error.setErrorMessage(`Account is not found. ${customerCareGP} E12`);
            break;
        case '13':
            error.setErrorMessage(`ACCOUNT CLOSED. This transaction has been requested from an account that has been closed.  ${customerCareGP} T13 `);
            break;
        case '14':
            error.setErrorMessage(`The credentials that corresponds to this account have been reported as lost or stolen. ${customerCareGP} E14 `);
            break;
        case '15':
            error.setErrorMessage(`EDIT ERROR. One or more of the data elements provided are incorrect: The Amount of Sale was not entered. For further assistance please contact Global Payments Gaming Services customer support at 1-800-500-1973 `);
            break;
        case '16':
            error.setErrorMessage(`PERMANENT ERROR. An invalid setting in the Merchant Account is preventing your request from being processed: Merchant ID Number Setup Error. ${customerCareGP} T16 `);
            break;
        case '17':
            error.setErrorMessage(`INVALID BANKING. Banking information is invalid, and an  enrollment cannot be processed: Invalid Routing Number ${customerCareGP} T17 `);
            break;
        case '18':
            error.setErrorMessage(`Fraud activity has been detected on this account. TRANSACTION DECLINED. Unable to approve your request at this time. ${customerCareGP} T18 `);
            break;
        case '19':
            error.setErrorMessage(`SELF-EXCLUDED MATCH. We have detected a positive match with the list of Self-Excluded patrons.  No transaction can be processed at this time. ${customerCareGP} E19 `);
            break;
        case '26':
            error.setErrorMessage(`A formatting error has been detected with the ID.  ${customerCareGP} E26 `);
            break;
        case '50':
        case '51':
        case '52':
            error.setErrorMessage(`The processing environment is temporarily unavailable and your Enrollment cannot be processed.  You can try your request again. ${customerCareGP} E50`);
            break;
        case '90':
            error.setErrorMessage(`Authentication error. ${customerCareGP} E90`);
            break;
        case '91':
            error.setErrorMessage(`A formatting error has been detected ${customerCareGP} E91`);
            break;
        case '92':
            error.setErrorMessage(`This transaction matches a previous transaction but has been declined because of the following condition: Duplicate transaction detected but timestamps differ by more than 2 minutes ${customerCareGP} 92 `);
            break;
        case '99':
        error.setErrorMessage(`An unexpected error has been received and your request cannot be processed.  You can try your request again. ${customerCareGP} 99 `);
            break;
        case 'INVALID_AMOUNT_MAX':
        case 'INVALID_AMOUNT_MIN':
        case 'INVALID_TEST_CC_NUMBER':
            error.setErrorMessage((!!error.getPayload()) ? error.getPayload() : "An error has occurred. Please contact support.");
            break;
        case 'OVER_DEPOSIT_LIMIT':
            //error.setErrorMessage((!!error.getPayload()) ? error.getPayload() : "An error has occurred. Please contact support.");
            error.setErrorMessage(`You have exceeded your maximum deposit limit.`);
            break;
        case 'PROCESSOR_ERROR':
            error.setErrorMessage('Sorry, an error occured processing your deposit. Please try again');
            break;
        case 'DUPLICATE_ACH_ACCOUNT':
            error.setErrorMessage('ACH account number has already been used.');
            break;
        case 'DENIED':
            let errorPayloadDenied= error.getPayload();
            if (errorPayloadDenied && !isUndefined(errorPayloadDenied.errors) && !isUndefined(errorPayloadDenied.errors)) {
                error.setErrorMessage(errorPayloadDenied.errors[0].message);
            } else {
                error.setErrorMessage('We are unable to process your request. Please verify your card information and retry. If you continue to receive this message  please try another card or contact member services.');
            }

            break;
        case 'INVALID_PARAMETER':
            error.setErrorMessage(error.getErrorMessage());
            break;
        case 'CUSTOMER_IS_A_TEST_ACCOUNT':
            error.setErrorMessage('Failed. Customer is a test account');
            break;
        case 'TEST_ACCOUNT_MAX_FUNDS_REACHED':
            error.setErrorMessage('Failed. Customer is a test account, max funds reached');
            break;
        case 'SIGHTLINE_NOTAPPROVED':
            // error.setErrorMessage(error.getPayload().message);
            this.setSightlineErrorMessage(error, error.getPayload());
            break;
        case 'UNKNOWN':
            let payload = error.getPayload();
            if (payload && payload.code != null) {
                switch (payload.code.toUpperCase()) {
                    case 'BAD_REQUEST':
                        error.setErrorMessage(payload.message);
                        break;
                }
            } else {
                error.setErrorMessage( 'An error has occurred. Please contact support.');
            }
            break;
        default:
            error.setErrorMessage((!!error.getPayload()) ? error.getPayload() : "An error has occurred. Please contact support.");
            break;
    }
    return error;
}
  public onCVVClick() {
    this.showCVV = true;
    setTimeout(() => {
      this.showCVV = false;
    }, 10 * 1000);
  }

  public getPaymentImage(name: string): string {
    let imageUrl: string;
    imageUrl = `url(${this.utils.getDepositCDNAAsset(name)})`;
    return imageUrl;
  }

  public getCardImage(paymentTypeCode: string) {

    let imageName: string;

    for (let item in this.paymentType) {
      if (this.paymentType[item].code == paymentTypeCode) {
        imageName = this.paymentType[item].image_url;
      }
    }

    let imageURL: string = this.getPaymentImage(imageName);
    return imageURL;
  }


  onBack = () => {
    return this.navigator.navigateTo('ShopPageComponent', { customModalClass: 'custom-shop-model-class-transparent', backdropDismiss: true });
  }

  getCardType(cardNumber) {
    const cardList = creditCardType(cardNumber);
    if (cardList && cardList[0]) {
      let cardTylpe = this.paymentType.find((res) => { return res.description == cardList[0].niceType });
      if (cardTylpe) {
        return { result: true, code: cardTylpe.code }
      }
      return { result: false }
    } else {
      return { result: false }
    }
  }

  scrollToTop(){
   this.widgetsContent.nativeElement.scrollTo({
     top: 0,
     behaviour: "smooth",
   });
  }
}
